import * as React from 'react';
import classNames from 'classnames';
import Image from 'next/image';
import Button from '@/components/ui/Button';
import Icon from '@/components/ui/Icon';
import styles from './styles.module.scss';

export interface IErrorPagePromotionProps {
  title: React.ReactNode;
  timeLeft: React.ReactNode;
  description: React.ReactNode;
  poolSize: string;
  buttonTitle: string;
  buttonHref: string;
  imageSrc: string;
}

const ErrorPagePromotion: React.FunctionComponent<IErrorPagePromotionProps> = (props) => {
  return (
    <div className={classNames(styles['error-page-promotion'])}>
      <div className={classNames(styles['error-page-promotion__title'])}>{props.title}</div>
      <Icon
        width={24}
        height={24}
        kind="arrow01-down"
      />
      <div className={classNames(styles['error-page-promotion__wrapper'])}>
        <div className={classNames(styles['error-page-promotion__time-left'])}>{props.timeLeft}</div>
        <div className={classNames(styles['error-page-promotion__image'])}>
          <Image
            alt=""
            src={props.imageSrc}
            fill={true}
            sizes="200px"
          />
        </div>
        <div className={classNames(styles['error-page-promotion__description'])}>{props.description}</div>
        <div className={classNames(styles['error-page-promotion__pool-size'])}>{props.poolSize}</div>
      </div>
      <Button
        title={props.buttonTitle}
        href={props.buttonHref}
        theme="primary"
      />
    </div>
  );
};

ErrorPagePromotion.displayName = 'ErrorPagePromotion';

export default ErrorPagePromotion;
